module.exports = __webpack_public_path__ + "img/elperiodic.1696106d.svg";